import { create } from 'zustand'

const ACCESS_TOKEN = 'token'

export interface AuthUser {
  id: string
  name: string
  email: string
  role: string
  requiresPasswordChange?: boolean
  hasCompletedTour?: boolean
}

interface AuthState {
  auth: {
    user: AuthUser | null
    setUser: (user: AuthUser | null) => void
    accessToken: string
    setAccessToken: (accessToken: string) => void
    refreshToken: string
    setRefreshToken: (refreshToken: string) => void
    resetAccessToken: () => void
    reset: () => void
    authLoaded: boolean
    setAuthLoaded: (loaded: boolean) => void
  }
}

export const useAuthStore = create<AuthState>()((set) => {
  const storedUser = localStorage.getItem('user')
  const initUser = storedUser ? JSON.parse(storedUser) : null
  const initToken = localStorage.getItem(ACCESS_TOKEN) || ''
  const initRefreshToken = localStorage.getItem('refreshToken') || ''

  return {
    auth: {
      user: initUser,
      setUser: (user) => {
        if (user) {
          localStorage.setItem('user', JSON.stringify(user))
        } else {
          localStorage.removeItem('user')
        }
        set((state) => ({ ...state, auth: { ...state.auth, user } }))
      },
      accessToken: initToken,
      setAccessToken: (accessToken) => {
        localStorage.setItem(ACCESS_TOKEN, accessToken)
        set((state) => ({ ...state, auth: { ...state.auth, accessToken } }))
      },
      refreshToken: initRefreshToken,
      setRefreshToken: (refreshToken) => {
        localStorage.setItem('refreshToken', refreshToken)
        set((state) => ({ ...state, auth: { ...state.auth, refreshToken } }))
      },
      resetAccessToken: () => {
        localStorage.removeItem(ACCESS_TOKEN)
        set((state) => ({ ...state, auth: { ...state.auth, accessToken: '' } }))
      },
      reset: () => {
        localStorage.removeItem(ACCESS_TOKEN)
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('user')
        set((state) => ({ ...state, auth: { ...state.auth, user: null, accessToken: '', refreshToken: '' } }))
      },
      authLoaded: !!initToken,
      setAuthLoaded: (loaded) => set((state) => ({ ...state, auth: { ...state.auth, authLoaded: loaded } })),
    },
  }
})

// export const useAuth = () => useAuthStore((state) => state.auth)
